<template>
  <div class="margin-top">
    <el-table
      :data="applyWithholdIntegralInfo.applys"
      border
      style="width: 100%">
      <el-table-column
        prop="iwId"
        :label="$t('applyWithholdIntegral.serialNumber')"
        align="center"
        width="100">
      </el-table-column>
      <el-table-column
        prop="integralId"
        :label="$t('applyWithholdIntegral.pointsId')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="integralName"
        :label="$t('applyWithholdIntegral.pointsName')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="shopId"
        :label="$t('applyWithholdIntegral.shopNumber')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="amount"
        :label="$t('applyWithholdIntegral.withdrawalAmount')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="applyUserName"
        :label="$t('applyWithholdIntegral.applicant')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="applyUserTel"
        :label="$t('applyWithholdIntegral.applicantPhone')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="bankNum"
        :label="$t('applyWithholdIntegral.bankAccount')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="bankNumName"
        :label="$t('applyWithholdIntegral.accountName')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="bankName"
        :label="$t('applyWithholdIntegral.openingBank')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="remark"
        :label="$t('applyWithholdIntegral.applicationNote')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="stateName"
        :label="$t('applyWithholdIntegral.status')"
        align="center">
      </el-table-column>
      <el-table-column
        prop="stateMsg"
        :label="$t('applyWithholdIntegral.reviewNote')"
        align="center">
      </el-table-column>
      <el-table-column
        :label="$t('applyWithholdIntegral.operation')"
        align="center"
        width="150">
        <template slot-scope="scope">
          <el-button
            size="mini"
            type="danger"
            @click="openDeleteIntegralWithdrawalModel(scope.row)">
            {{ $t('applyWithholdIntegral.delete') }}
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-row class="margin-top">
      <el-col :span="12" :offset="12">
        <el-pagination
          @current-change="handlePageChange"
          :current-page="pagination.currentPage"
          :page-size="pagination.pageSize"
          layout="total, prev, pager, next, jumper"
          :total="pagination.total">
        </el-pagination>
      </el-col>
    </el-row>

    <delete-apply-withhold-integral ref="deleteApplyWithholdIntegral" />
  </div>
</template>

<script>
import { listIntegralWithdrawal } from '@/api/shop/integralApi'
import { getShopId } from '@/api/shop/shopApi'
import DeleteApplyWithholdIntegral from '@/components/shop/deleteApplyWithholdIntegral/deleteApplyWithholdIntegral'

export default {
  name: 'ApplyWithholdIntegral',
  components: {
    DeleteApplyWithholdIntegral
  },
  data() {
    return {
      applyWithholdIntegralInfo: {
        applys: [],
        integralId: '',
        integralName: ''
      },
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      }
    }
  },
  methods: {
    async switch(data) {
      this.applyWithholdIntegralInfo.integralId = data.integralId
      this.applyWithholdIntegralInfo.integralName = data.integralName
      await this.loadApplyWithholdIntegralData()
    },
    async loadApplyWithholdIntegralData() {
      try {
        const params = {
          shopId: getShopId(),
          integralId: this.applyWithholdIntegralInfo.integralId,
          page: this.pagination.currentPage,
          row: this.pagination.pageSize
        }
        const res = await listIntegralWithdrawal(params)
        this.applyWithholdIntegralInfo.applys = res.data
        this.pagination.total = res.records
      } catch (error) {
        console.error('Failed to load apply withhold integral:', error)
      }
    },
    handlePageChange(currentPage) {
      this.pagination.currentPage = currentPage
      this.loadApplyWithholdIntegralData()
    },
    openDeleteIntegralWithdrawalModel(apply) {
      this.$refs.deleteApplyWithholdIntegral.open(apply)
    }
  }
}
</script>

<style scoped>
.margin-top {
  margin-top: 20px;
}
</style>